<template>
    <inertia-link
        :href="href"
        :title="post.title"
        class="row text-grey-darker hover:text-grey-darker">
        <div class="mt-4 md:mt-0 ml-4">
            <div class="row gutters-1 items-start">
                <div class="col-auto">
                    <div class="bg-grey-dark text-white px-1">
                        <font-awesome-icon icon="volume-up"/>
                    </div>
                </div>
                <div class="col">
                    <h3 class="font-semibold leading-tight mb-2" v-html="post.title"/>
                </div>
            </div>
            <div class="text-xs mb-2">
                <p class="font-semibold" v-html="authorList"/>
                <p>
                    {{ publishedAt }} |
                    {{ duration }} mins |
                    {{ categoryList }}
                    <span v-if="post.expertise_level">|</span>
                    {{ expertiseLevel }}
                </p>
            </div>
            <div class="text-sm" v-html="post.summary"/>
        </div>
    </inertia-link>
</template>

<script>

import dayjs from "dayjs";
import {PostType} from "@admin/Lib/Enums";
import PostThumbnail from "@app/Shared/Components/PostThumbnail";

export default {

    name: "PostPanel",

    props: {
        post: {
            type: Object,
            required: true,
        },
    },

    components: {
        PostThumbnail
    },

    computed: {
        href() {
            switch (this.post.type) {
                case PostType.Tutorial:
                    return `/tutorial/${this.post.id}`
                case PostType.CaseReport:
                    return `/case-report/${this.post.id}`
            }
        },
        publishedAt() {
            return dayjs(this.post.published_at).format('MMMM D, YYYY')
        },
        authorList() {
            return _.sortBy(this.post.authors, ['pivot.position']).map(item => item.name).join(', ')
        },
        duration() {
            return Math.ceil(this.post.duration / 60);
        },
        expertiseLevel() {
            return _.startCase(this.post.expertise_evel);
        },
        categoryList() {
            return _.chain(this.post.categories)
                .groupBy('parent_id')
                .map(items => {
                    const parentName = items[0].parent.name;
                    const names = items.map(item => item.name).join('; ');

                    return `${parentName} (${names})`
                })
                .value()
                .join('|')
        }
    }
};

</script>